import React,{ useState } from 'react';
//import {FiMenu,} from 'react-icons/fi';
import {BsFillPersonPlusFill} from 'react-icons/bs';
import {ImEnter,ImExit} from 'react-icons/im';
import {AiOutlineQuestionCircle,AiOutlineMail} from 'react-icons/ai';
import '../App.css';
import Contact from './Contact.js';
import FAQ from './FAQ.js';
import SignOut from './SignOut.js';
import SignIn from './SignIn.js';
import SignUp from './SignUp.js';

function Header(props){
  console.log("HeaderProps:",props)
  //Modal functions and variables
  const UseContact = () => {
    const [showContact, setShowContact] = useState(false);
    function toggleContact() {
      setShowContact(!showContact);
    }
    return {
      showContact,
      toggleContact,
    }
  };

  const UseFAQ = () => {
    const [showFAQ, setShowFAQ] = useState(false);
    function toggleFAQ() {
      setShowFAQ(!showFAQ);
    }
    return {
      showFAQ,
      toggleFAQ,
    }
  };

  const UseSignIn = () => {
    const [showSignIn, setShowSignIn] = useState(false);
    function toggleSignIn() {
      setShowSignIn(!showSignIn);
    }
    return {
      showSignIn,
      toggleSignIn,
    }
  };

  const UseSignUp = () => {
    const [showSignUp, setShowSignUp] = useState(false);
    function toggleSignUp() {
      setShowSignUp(!showSignUp);
    }
    return {
      showSignUp,
      toggleSignUp,
    }
  };

  const UseSignOut = () => {
    const [showSignOut, setShowSignOut] = useState(false);
    function toggleSignOut() {
      setShowSignOut(!showSignOut);
    }
    return {
      showSignOut,
      toggleSignOut,
    }
  };

  const {showContact, toggleContact} = UseContact();
  const {showFAQ, toggleFAQ} = UseFAQ();
  const {showSignIn, toggleSignIn} = UseSignIn();
  const {showSignUp, toggleSignUp} = UseSignUp();
  const {showSignOut, toggleSignOut} = UseSignOut();
  let userInfo = props.userInfo;


  //function for passing back the changed states to App.js
  function handleChange(newUserInfo) {
        props.onChange(newUserInfo);
    }

    return (
      <div>
        <header>
          <div className="navbar">
            <div className="navbar-left">
              <button className="blue flexButton" onClick={toggleFAQ}><AiOutlineQuestionCircle className="iconL"/> FAQ</button>
              <button className="blue flexButton" onClick={toggleContact}><AiOutlineMail className="iconL"/> Contact</button>
            </div>
            <div className="navbar-center"> ODE </div>
            <div className="navbar-right">
                <button style={{display: props.userInfo.signedIn ? "inline-flex" : "none"}}
                className="blue flexButton"
                onClick={toggleSignOut}><ImExit className="iconL"/>   Sign Out</button>
              <button style={{display: props.userInfo.signedIn ? "none" : "inline-flex"}}
                className="blue flexButton"
                onClick={toggleSignIn}><ImEnter className="iconL"/> Sign In</button>
              <button style={{display: props.userInfo.signedIn ? "none" : "inline-flex"}}
                className="blue flexButton"
                onClick={toggleSignUp}><BsFillPersonPlusFill className="iconL"/> Sign Up</button>
            </div>
          </div>
        </header>
        <Contact isShowing={showContact} hide={toggleContact} />
        <FAQ isShowing={showFAQ} hide={toggleFAQ}/>
        <SignIn isShowing={showSignIn} hide={toggleSignIn} userInfo={userInfo} onChange={handleChange}/>
        <SignUp isShowing={showSignUp} hide={toggleSignUp} userInfo={userInfo} onChange={handleChange}/>
        <SignOut isShowing={showSignOut} hide={toggleSignOut} userInfo={userInfo} onChange={handleChange}/>
      </div>
    );
}

export default Header
